<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
           
            <div class="card-body pb-1">
                <div class="card-datatable text-nowrap">
                    <div class="d-flex mb-3" style="align-items: center;justify-content: space-between;">
                        <div class="input-group input-group-merge w-auto">
                            <input type="text" id="first-name-icon" class="form-control" name="fname-icon" placeholder="ابحث فى الاشعارات" (keyup)="updateFilter($event)">
                            <span class="input-group-text">
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10.5867" r="7" stroke="#3F8260" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21 21.5867L15 15.5867" stroke="#3F8260" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </div>
                        <div class="d-flex">
                            <select id="per-page" class="form-control pl-3 pr-0" (change)="onLimitChange($event.target.value)">
                              <option *ngFor="let option of pageLimitOptions" [value]="option.value" [selected]="option.value == currentPageLimit">
                                {{ option.value }}
                              </option>
                            </select>
                            <button class="btn btn-primary waves-effect py-0 ml-2" type="button" (click)="modalOpenLG(modalNotification)" rippleEffect>
                              + <span class="pl-1">إشعار جديد </span>
                            </button>
                        </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-12">
                        <ngx-datatable
                          #table
                          id="ngxTable"
                          class="material bootstrap core-bootstrap"
                          [rows]="rows"
                          [columnMode]="'force'"
                          [headerHeight]="40"
                          [footerHeight]="50"
                          [limit]="10"
                          [rowHeight]="'auto'"
                          [selected]="chkBoxSelected"
                          (select)="customChkboxOnSelect($event)"
                          [scrollbarH]="true"
                          [selectAllRowsOnPage]="true"
                        >
                          <ngx-datatable-column name="#" prop="#" [width]="30"></ngx-datatable-column>
                          <ngx-datatable-column name="عنوان الاشعار" prop="عنوان الاشعار"></ngx-datatable-column>
                          <ngx-datatable-column name="محتوى الاشعار" prop="محتوى الاشعار">
                            <ng-template let-value="value" ngx-datatable-cell-template>
                              <div class="text-wrap">{{ value }}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="البلد" prop="البلد"></ngx-datatable-column>
                          <ngx-datatable-column name="التوقيت" prop="التوقيت"></ngx-datatable-column>
                        </ngx-datatable>
                      </div>
                      
                    </div>

                    <!-- <div class="modal-size-default d-inline-block">
                      <ng-template #modalDelete let-modal>
                        <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel160"></h5>
                          <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close" title="إغلاق">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center" tabindex="0" ngbAutofocus>
                          <h4>تأكيد حذف الفئة</h4>
                          <p class="pt-1">سيتم حذف الفئة . هل مازلت تريد المتابعة ؟</p>
                          <div class="demo-spacing-0">
                            <div class="alert alert-danger p-75" role="alert" dir="rtl">
                              <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                              <span>سيتم إزالة الفئة ولن يكون بالإمكان استعادتها لاحقًا.</span>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer m-auto">
                          <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
                            حذف
                          </button>
                          <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" rippleEffect>
                            تراجع
                          </button>
                        </div>
                      </ng-template>
                    </div> -->

                    <div class="modal-size-lg d-inline-block">
                      <ng-template #modalNotification let-modal>
                        <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel160"></h5>
                          <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close" title="إغلاق">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body" tabindex="0" ngbAutofocus>
                          <h4 class="text-center">إضافة إشعار جديد</h4>
                          <div class="demo-spacing-0">
                            <form class="row" dir="rtl">
                              <div class="col-md-12">
                                <div class="mb-1">
                                  <label class="form-label" for="notificationTitle">عنوان الإشعار</label>
                                  <input type="text" id="notificationTitle" class="form-control" name="notificationTitle" placeholder="ادخل عنوان الإشعار">
                                </div>
                                <div class="mb-1">
                                  <label class="form-label" for="notificationContent">محتوى الإشعار</label>
                                  <textarea id="notificationContent" rows="10" class="form-control" name="notificationContent" placeholder="ادخل محتوى الإشعار"></textarea>
                                </div>
                                <div class="mb-1">
                                  <label class="form-label" for="notificationContent">البلد الموجه لها الإشعار</label>
                                  <ng-select [items]="country" bindLabel="country" bindValue="country" [placeholder]="'اختر بلد التوجيه'">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{ item.country || 'Unnamed group' }}
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="modal-footer m-auto">
                          <button type="button" class="btn btn-success" (click)="modal.close('Accept click')" rippleEffect>
                            إرسال الإشعار للمستخدمين
                          </button>
                          <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" rippleEffect>
                            تراجع
                          </button>
                        </div>
                      </ng-template>
                    </div>

                  </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
